module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /~/babel-polyfill/~/core-js/modules/_html.js
// module id = 308
// module chunks = 0